import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { NavigateFunction, useNavigate } from 'react-router';
import { z } from 'zod';

import { zNonEmptyString } from '@synapex/tools/utils';
import ArrowRight from '@synapex/frontend-shared/icons/arrow-right-24.svg?react';
import { AdvertiserAccount } from '@synapex/shared2/gateway-rest-api';

// import { useCreateAccountMutation } from '@/true-fsd/data/user/loader-query-mutation'
import { Button } from '@/true-fsd/shared/ui/ButtonLink';
import { RhfLabeledInput } from '@/true-fsd/shared/ui/Input';

import classes from './CreateAccount.module.scss';
// import { accountPathPrefix } from '@/true-fsd/data/entities'
import { ComponentType, ReactNode } from 'react';
import { useNewWsStore } from '@/true-fsd/data/advertiser-account/new-workspace-store';

//schema
const schema = z.object({
  name: zNonEmptyString('Обязательное поле'),
});

type FormValues = z.input<typeof schema>;

//values
// const DEFAULT_FORM_VALUES: FormValues = {
//     name: '',
// }
const makeCreateDto = ({
  name,
}: FormValues): AdvertiserAccount.CreateInputDto => {
  return {
    name,
  };
};

//hook
const useCreateAccount = ({ onNewAccountUpdated }: CreateAccountProps) => {
  const { newAccount, setNewAccount } = useNewWsStore(
    ({ newAccount, setNewAccount }) => ({
      newAccount,
      setNewAccount,
    }),
  );
  const navigate = useNavigate();

  const {
    formState,
    handleSubmit,
    control,
    // setError
  } = useForm({
    resolver: zodResolver(schema),

    defaultValues: newAccount,
  });

  // const { mutate } = useCreateAccountMutation({
  //     onSuccess: (acc) => navigate(`${accountPathPrefix(acc)}/workspace/new`),
  //     onError: (error) => {
  //         console.log(error)
  //         setError('root', {
  //             type: 'custom',
  //             message: 'Не удалось добавить аккаунт',
  //         })
  //     },
  // })

  // const formHasErrors =
  //     !formState.isValid || Object.keys(formState.errors).length > 0

  const onSubmit = handleSubmit((values) => {
    // mutate(makeCreateDto(values))
    setNewAccount(makeCreateDto(values));
    onNewAccountUpdated(navigate);
  });

  const isSubmitting = formState.isSubmitting;

  return {
    onSubmit,
    isSubmitting,
    control,
    error: formState.errors.root?.message,
  };
};

type RenderLayoutProps = {
  RenderForm: ComponentType<{ children: ReactNode; className: string }>;

  slotHeader: ReactNode;
  slotTitle: ReactNode;
  slotButtons: ReactNode;
  slotError: ReactNode;

  children: ReactNode;
};

//
export type CreateAccountProps = {
  RenderLayout: (p: RenderLayoutProps) => ReactNode;
  onNewAccountUpdated: (n: NavigateFunction) => void;
  description?: ReactNode;
};
export const CreateAccount = (props: CreateAccountProps) => {
  const { RenderLayout, description } = props;
  const { control, isSubmitting, onSubmit, error } = useCreateAccount(props);

  const RenderForm: RenderLayoutProps['RenderForm'] = ({
    children,
    className,
  }) => (
    <form onSubmit={onSubmit} className={className}>
      {children}
    </form>
  );

  return (
    <RenderLayout
      RenderForm={RenderForm}
      slotHeader={'Создание аккаунта'}
      slotTitle={'Создание аккаунта рекламодателя'}
      slotError={error}
      slotButtons={
        <Button
          type="submit"
          SuffixIcon={ArrowRight}
          variant={'primary'}
          loading={isSubmitting}
        >
          Далее
        </Button>
      }
    >
      {description && <div className={classes.description}>{description}</div>}
      <RhfLabeledInput
        label={'Название компании'}
        placeholder={'Synapex.ai'}
        name="name"
        control={control}
      />
    </RenderLayout>
  );
};
